import { Sort } from './common';
import { FileType } from './file';
import { Patient } from 'types';

export type GetPatientMessagesRequestParams = {
  page?: number;
  size?: number;
  sort?: Sort[];
};

export type PatientMessagesResponse = {
  totalPages: number;
  totalElements: number;
  size: number;
  content: MessagesType[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  last: boolean;
  numberOfElements: number;
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
  };
  empty: boolean;
};

export type PatientMessagesInfo = Omit<PatientMessagesResponse, 'content'>;

export type MessagesType = {
  id: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  body: string;
  type: TypeOfMessages;
  hashtags: string[];
  replyToMessageId: number;
  attachmentFile: {
    id: string;
    name: string;
    type: string;
    size: number;
    url: string;
  };
  attachmentLink: string;
  patientCaseId: number;
  isRead: boolean;
  reactions: { createdBy: string; reactions: string[] }[];
};

export enum TypeOfMessages {
  TEXT = 'TEXT',
  PHOTO = 'PHOTO',
  LINK = 'LINK',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
}

export type FeedItem = {
  patientCase: Patient;
  message: MessagesType;
};

export type FeedListInfoResponse = PatientMessagesInfo & {
  content: FeedItem[];
};

export enum AttachmentsTab {
  IMAGES = 'IMAGES',
  FILES = 'FILES',
  LINKS = 'LINKS',
}

export enum DiscussionTab {
  CHAT = 'CHAT',
  ATTACHMENTS = 'ATTACHMENTS',
}

export type GetMessagesAttachmentsRequestParams = {
  attachmentType?: TypeOfMessages.FILE | TypeOfMessages.LINK;
  fileTypes?: FileType[];
  page?: number;
  size?: number;
  sort?: Sort[];
};

export type AttachmentMessageContent = {
  messageId: number;
  file: {
    id: string;
    name: string;
    type: string;
    size: number;
    url: string;
  };
  link: 'string';
};

export type AttachmentMessageResponseType = Omit<PatientMessagesResponse, 'content'> & {
  content: AttachmentMessageContent[];
};
